

















import { Component, Prop, Emit, Vue } from 'vue-property-decorator';

@Component
export default class ListLinkItem extends Vue {
  @Prop()
  private active!: boolean;

  @Prop()
  private index!: number;

  @Prop()
  private icon!: string;

  @Prop()
  private title!: string;

  @Prop()
  private path!: string;
}
